export default function FormField({
  label, error, hint, required, children, className = '', htmlFor,
}) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label htmlFor={htmlFor} className="text-label uppercase text-ink-muted mb-1.5 block">
          {label}
          {required && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      {children}
      {hint && !error && (
        <p className="text-small text-ink-muted">{hint}</p>
      )}
      {error && (
        <p className="text-small text-danger mt-1">{error}</p>
      )}
    </div>
  );
}

export function Input({ className = '', ...props }) {
  return (
    <input
      className={`
        w-full min-h-touch px-3 rounded-control border border-border-strong bg-surface-card
        text-body text-ink placeholder:text-ink-muted transition-colors duration-state
        focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/15
        disabled:bg-surface-sunken disabled:text-ink-faint disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    />
  );
}

export function Select({ className = '', children, ...props }) {
  return (
    <select
      className={`
        w-full min-h-touch px-3 rounded-control border border-border-strong bg-surface-card
        text-body text-ink transition-colors duration-state
        focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/15
        disabled:bg-surface-sunken disabled:text-ink-faint disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    >
      {children}
    </select>
  );
}

export function Textarea({ className = '', ...props }) {
  return (
    <textarea
      className={`
        w-full px-3 rounded-control border border-border-strong bg-surface-card
        text-body text-ink placeholder:text-ink-muted transition-colors duration-state
        focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/15
        disabled:bg-surface-sunken disabled:text-ink-faint disabled:cursor-not-allowed
        min-h-[96px] py-3 resize-y
        ${className}
      `}
      {...props}
    />
  );
}
